/**
 * @generated SignedSource<<edd1ab4c4a4c63fa77dbcc07d27a5729>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditDatesAdd_package$data = {
  readonly id: string;
  readonly " $fragmentType": "PackageEditDatesAdd_package";
};
export type PackageEditDatesAdd_package$key = {
  readonly " $data"?: PackageEditDatesAdd_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDatesAdd_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditDatesAdd_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "e153656e347ecec3c0fe26382fe18254";

export default node;
